import * as React from 'react';
import styled from 'styled-components';

import { Field } from '../Shared/Fields';
import { IFilterType } from './types';

type IInclusionFilter = {
  handleSelectChange: Function,
  filterId: IFilterType,
}

const SelectBoxView = styled.select`
  width: 100%;
`;

const InclusionFilter: React.FC<IInclusionFilter> = (props) => {
  const { handleSelectChange, filterId } = props;
  function handleChange(event: React.ChangeEvent) {
    const target = (event.currentTarget as HTMLSelectElement)
    const selectedValue: string = target.options[target.selectedIndex].value;
    console.log(selectedValue, filterId);
    handleSelectChange({ filterId, selectedValues: [selectedValue] });
  }
  return (
    <Field className="dropdown">
      <SelectBoxView id={filterId} onChange={handleChange}>
        {props.children}
      </SelectBoxView>
    </Field>
  )
};

export default InclusionFilter;
